import React, { useCallback, useState } from 'react';
import { PieChart, Pie, Sector, ResponsiveContainer, Cell } from 'recharts';

export default function CustomActiveShapePieChart({ chartTitle = "", unitSignDirection = "left", unitSign = "", data }) {
  const demoUrl = 'https://codesandbox.io/s/pie-chart-with-customized-active-shape-y93si';

  const COLORS = [
  "#0088FE", // Blue
  "#00C49F", // Teal
  "#FFBB28", // Amber
  "#FF8042", // Orange
  "#A28EFF", // Light Purple
  "#FF5A92", // Pink
  "#00B8D9", // Cyan
  "#36B37E", // Green
  "#F76666", // Coral Red
  "#A9A9A9", // Gray
];
  const [activeIndex, setActiveIndex] = useState(0);

  const onPieEnter = useCallback(
    (_, index) => {
      setActiveIndex(index);
    },
    [setActiveIndex]
  );


  const renderActiveShape = (props) => {
    const RADIAN = Math.PI / 180;
    const {
      cx,
      cy,
      midAngle,
      innerRadius,
      outerRadius,
      startAngle,
      endAngle,
      fill,
      payload,
      percent,
      value,
    } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? "start" : "end";

    return (
      <g>
        <text x={cx} y={cy-12} dy={0} textAnchor="middle" fill={"#999"}>
          {/* {payload.name} */}
          {`${unitSignDirection === "left" ? unitSign : ""}${value}${unitSignDirection === "right" ? unitSign : ""}`}
        </text>
        <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
          {/* {payload.name} */}
          {`${chartTitle ? chartTitle : ``}`}
        </text>
        <text x={cx} y={cy} dy={25} textAnchor="middle" fill="#999" fontSize="12" >
          {`(${(percent * 100).toFixed(2)}%)`}
        </text>
        <Sector
          cx={cx}
          cy={cy}
          innerRadius={innerRadius}
          outerRadius={outerRadius}
          startAngle={startAngle}
          endAngle={endAngle}
          fill={fill}
        />
        <Sector
          cx={cx}
          cy={cy}
          startAngle={startAngle}
          endAngle={endAngle}
          innerRadius={outerRadius + 6}
          outerRadius={outerRadius + 10}
          fill={fill}
        />
        <path
          d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
          stroke={fill}
          fill="none"
        />
        <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
        <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          textAnchor={textAnchor}
          fill="#333"
        >
        {/* {`${chartTitle ? chartTitle : ``} ${unitSignDirection === "left" ? unitSign : ""}${value}${unitSignDirection === "right" ? unitSign : ""}`} */}
        {payload.name}
        </text>
        {/* <text
          x={ex + (cos >= 0 ? 1 : -1) * 12}
          y={ey}
          dy={18}
          textAnchor={textAnchor}
          fill="#999"
        >
          {`(${(percent * 100).toFixed(2)}%)`}
        </text> */}
      </g>
    );
  };

  return (
    <ResponsiveContainer width="100%" height={300}>
      {/* <PieChart width={400} height={400}> */}
      <PieChart >
        <Pie
          chartTitle={chartTitle}
          activeIndex={activeIndex}
          activeShape={renderActiveShape}
          data={data}
          // cx={200}
          // cy={200}
          cx="50%"
          cy="50%"
          innerRadius={60}
          outerRadius={80}
          fill="#6366f1"
          dataKey="value"
          onMouseEnter={onPieEnter}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );

}
